module.exports = __webpack_public_path__ + "static/media/increase_arrow.172b5472.svg";